import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { SettingsModal } from './settings-modal';
import { selectIsSettingsV2Shown } from './slice';
import { SettingsProps } from './types';
import { SettingsV2 } from './v2';

export const SettingsVersioner: FunctionComponent<SettingsProps> = (props) => {
    const isSettingsV2Shown = useSelector(selectIsSettingsV2Shown);

    const SettingsComponent = isSettingsV2Shown ? SettingsV2 : SettingsModal;

    return <SettingsComponent {...props} />;
};
